import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import { renderTrustedMarkdown } from '~/functions/markdown'
import {
  useUpsertGhgSavingPotentialMutation,
  type ImpactSolutionType,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmissionSourcesScenario',
  props: {
    disabled: { type: Boolean, default: false },
    ghgSavingPotentialId: { default: undefined },
    ghgSavingPotentialData: { default: undefined },
    impactSolutionData: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { disabled: boolean, ghgSavingPotentialId: number, ghgSavingPotentialData: Record<string, any>, impactSolutionData: ImpactSolutionType };



const route = useRoute()
const ventureId = computed(() => route.params.venture as string)
const showOptionAInstructions = ref(false)

const { mutate: upsertGhgSavingPotential } = useUpsertGhgSavingPotentialMutation()

const ghg = computed(() => props.ghgSavingPotentialData ?? props.impactSolutionData?.ghgSavingPotential)
const isScenarioA = computed(() => ghg.value?.isScenarioA ?? true)
const isScenarioB = computed(() => !isScenarioA.value)
const selectedScenario = computed(() => (isScenarioA.value ? 'A' : 'B'))
const impactProfile = computed(() => ghg.value?.impactProfileKind)
const preComputedBaselineGhg = computed(() => ghg.value?.preComputedBaselineGhg ?? 0)
const preComputedSolutionGhg = computed(() => ghg.value?.preComputedSolutionGhg ?? 0)
const scenarioBComments = computed(() => ghg.value?.scenarioBComments ?? '')

const updateGhgSavingPotential = (value: Record<string, unknown>) => {
  if (props.disabled || !props.ghgSavingPotentialId) return
  upsertGhgSavingPotential({
    input: {
      id: props.ghgSavingPotentialId,
      ventureId: ventureId.value,
      ...value,
    },
  })
}

const scenarioChanged = (newScenario: string) => {
  if (props.disabled) return
  updateGhgSavingPotential({ isScenarioA: newScenario === 'A' })
}

const onBaselineGhgInput = (val: string | number) => {
  updateGhgSavingPotential({
    isScenarioA: isScenarioA.value,
    preComputedBaselineGhg: parseFloat(String(val)),
    preComputedSolutionGhg: parseFloat(String(preComputedSolutionGhg.value)),
  })
}

const onSolutionGhgInput = (val: string | number) => {
  updateGhgSavingPotential({
    isScenarioA: isScenarioA.value,
    preComputedBaselineGhg: parseFloat(String(preComputedBaselineGhg.value)),
    preComputedSolutionGhg: parseFloat(String(val)),
  })
}

const onScenarioBCommentsInput = (val: string | number) => {
  updateGhgSavingPotential({ scenarioBComments: String(val) })
}

return { __sfc: true,props, route, ventureId, showOptionAInstructions, upsertGhgSavingPotential, ghg, isScenarioA, isScenarioB, selectedScenario, impactProfile, preComputedBaselineGhg, preComputedSolutionGhg, scenarioBComments, updateGhgSavingPotential, scenarioChanged, onBaselineGhgInput, onSolutionGhgInput, onScenarioBCommentsInput, renderTrustedMarkdown }
}

})